const NUMBER_REG_EXP = /\d+/g;

export function resolveReference (styles, reference) {
  const index = resolveReferenceToIndex(reference);
  return styles[index];
}

export function resolveReferenceToIndex (reference) {
  // This is a shortcut to not having to respect the whole JSON Reference spec
  // from: https://tools.ietf.org/id/draft-pbryan-zyp-json-ref-03.html
  // It assumes that the given reference has the pattern "#/styles[123]".
  return reference.match(NUMBER_REG_EXP).map(Number)[0];
}
